module.exports = __webpack_public_path__ + "static/media/product-hospital-monitor.697234f6.webp";